import { inject, Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { ManagePermissionsBillingService } from '@tgx/shared/permissions';
import { WebComponent, WebFeature } from '@tgx/shared/enums';

@Injectable({
  providedIn: 'root',
})
export class BillingGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private managePermissionsBillingService = inject(ManagePermissionsBillingService);

  canActivate(): boolean | UrlTree {
    const permissionsVisibility = this.managePermissionsBillingService.checkVisibility(
      WebComponent.SETTINGS,
      WebFeature.BILLING,
    );

    return permissionsVisibility.isVisible ? true : this.router.parseUrl('/dashboard');
  }

  canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }
}
